import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
const ZOOM_CONTROL_WIDTH_XS = 90;
const ZOOM_CONTROL_HEIGHT_XS = 40;
const ZOOM_CONTROL_WIDTH_SM = 40;
const ZOOM_CONTROL_HEIGHT_SM = 90;
/**
 * Gallery zoom control
 */
export const galleryZoomControlsContainerStyles = ({ theme }) => css `
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	grid-area: slide;
	position: absolute;
	right: ${pxToRem(theme.spacing['300'])};
	bottom: ${pxToRem(theme.spacing['300'])};
	height: ${pxToRem(ZOOM_CONTROL_HEIGHT_XS)};
	width: ${pxToRem(ZOOM_CONTROL_WIDTH_XS)};
	flex-direction: row-reverse;

	::selection {
		background: transparent;
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		right: ${pxToRem(theme.spacing['400'])};
		bottom: ${pxToRem(theme.spacing['400'])};
		width: ${pxToRem(ZOOM_CONTROL_WIDTH_SM)};
		height: ${pxToRem(ZOOM_CONTROL_HEIGHT_SM)};
		flex-direction: column;
	}
`;
export const GalleryZoomControlsContainer = styled.span `
	${galleryZoomControlsContainerStyles}
`;
